// import { useEffect, useRef } from 'react';
// import Alert from '@mui/material/Alert';
// import Snackbar from '@mui/material/Snackbar';
// import { TOGGLE_GLOBAL_TOAST } from '../../store/actions/action-types';
// import { useDispatchToProps, useStateToProps } from '../../store/actions/actions';

// function GlobalToast() {
//   let visibilityTimeout = null;
//   const toggleGlobalToast = useDispatchToProps(TOGGLE_GLOBAL_TOAST);
//   const { globalToast } = useStateToProps((state) => ({
//     globalToast: state.global.globalToast,
//   }));

//   if (!globalToast) {
//     return null;
//   }

//   const { visibility, timeout = 10000, type = 'error', label } = globalToast;

//   const handleChangeVisibility = () => {
//     clearTimeout(visibilityTimeout);
//     toggleGlobalToast({
//       ...globalToast,
//       visibility: false,
//       label: '',
//     });
//   };

//   // eslint-disable-next-line react-hooks/rules-of-hooks
//   useEffect(() => {
//     if (visibility === true) {
//       visibilityTimeout = setTimeout(() => {
//         handleChangeVisibility();
//       }, timeout + 1000);
//     }
//     return () => clearTimeout(visibilityTimeout);
//   }, [visibility]);

//   return (
//     <Snackbar
//       open={visibility}
//       autoHideDuration={timeout}
//       anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       onClose={handleChangeVisibility}
//     >
//       <Alert severity={type} variant="filled" onClose={handleChangeVisibility}>
//         {label}
//       </Alert>
//     </Snackbar>
//   );
// }

// export default GlobalToast;
import React, { useEffect, useRef, useState } from 'react';
import Alert from '@mui/material/Alert';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { TOGGLE_GLOBAL_TOAST } from '../../store/actions/action-types';
import { useDispatchToProps, useStateToProps } from '../../store/actions/actions';

function ToastNotifier() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const notificationIdsRef = useRef(new Map());
  const [pendingNotifications, setPendingNotifications] = useState([]);
  const toggleGlobalToast = useDispatchToProps(TOGGLE_GLOBAL_TOAST);
  const { globalToast } = useStateToProps((state) => ({
    globalToast: state.global.globalToast,
  }));

  useEffect(() => {
    if (globalToast && globalToast.visibility === true && globalToast.label) {
      // Add to pending notifications queue if not already there
      setPendingNotifications((prev) => {
        const exists = prev.some(
          (item) => item.label === globalToast.label && item.type === globalToast.type,
        );

        if (!exists) {
          return [...prev, { ...globalToast }];
        }
        return prev;
      });

      // Reset the global toast state immediately to allow for more notifications
      setTimeout(() => {
        toggleGlobalToast({
          visibility: false,
          label: '',
          type: 'error',
        });
      }, 100);
    }
  }, [globalToast, toggleGlobalToast]);

  // Process the pending notifications queue
  useEffect(() => {
    if (pendingNotifications.length > 0) {
      const notification = pendingNotifications[0];
      const { type = 'error', label, timeout = 10000 } = notification;

      // Display the notification
      const key = enqueueSnackbar(label, {
        variant: type,
        autoHideDuration: timeout,
        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
        content: (snackKey) => (
          <Alert
            severity={type}
            variant="filled"
            onClose={() => closeSnackbar(snackKey)}
            sx={{
              width: '100%',
              color: '#fff',
              alignItems: 'center',
              alignContent: 'center',
              lineHeight: 'inherit',
            }}
          >
            {label}
          </Alert>
        ),
        onClose: () => {
          // Remove from pending notifications when closed
          setPendingNotifications((prev) => prev.filter((item) => item.label !== label));
        },
      });

      notificationIdsRef.current.set(label, key);

      // Remove from pending queue after processing
      setPendingNotifications((prev) => prev.slice(1));
    }
  }, [pendingNotifications, enqueueSnackbar, closeSnackbar]);

  return null;
}

function GlobalToast() {
  return (
    <SnackbarProvider maxSnack={10} preventDuplicate dense>
      <ToastNotifier />
    </SnackbarProvider>
  );
}

export default GlobalToast;
